<template>
  <el-table-column
    prop="net_price"
    label="Nettó"
    show-overflow-tooltip
    align="right"
  >
    <template slot-scope="scope">
      {{ scope.row.net_price | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'net_price',
};
</script>
